export const GET_USER_PROFILE = "/api/user/userDetails/";
export const INSTITUTION_LIST = "/api/user/findUserCategoryTypeBYMainCategory/2";
export const GET_USER_CATEGORY_TYPE = "/api/user/getUserCategoryType";

// Dummy update endpoint for profile edits (multipart)
export const UPDATE_USER_PROFILE_DETAILS = "/api/user/updateProfile";


// Login OTP URL
// export const LOGIN_MOBILE_OTP = "api/sendLoginOtp/user";
export const LOGIN_MOBILE_OTP = "api/getOtp/mobile";
// export const RESET_LOGIN_MOBILE = "api/resendLoginOtp/user";
// export const OTP_VERIFICATION_MOBILE = "api/LoginWithOtp/user";
export const UPDATE_USER_MOBILE = "api/user/updateMobile";


// export const EMAIL_OTP_GENERATION_URL = "/registration/sendOtpViaEmail";
// export const EMAIL_OTP_VERIFICATION_URL = "/registration/verifyEmailOtp";
// export const UPDATE_USER_EMAIL = "api/user/updateEmail";



export const EMAIL_OTP_GENERATION_URL = "/api/getOtp/email";
// export const EMAIL_OTP_VERIFICATION_URL = "/registration/verifyEmailOtp";
export const UPDATE_USER_EMAIL = "api/user/updateEmail";


// export const EMAIL_OTP_GENERATION_URL = "/api/sendOTPVerificationEmail";
// export const EMAIL_OTP_VERIFICATION_URL = "/api/sendOTPVerificationEmail";

export const UPLOAD_DOCUMENT = "/api/user/uploadDocument"


export const GET_KIT_SIZE_LIST = "/api/getKitSizes";
export const CHECK_FIELD_UPDATE = "/api/user/checkUpdate";
